import { render, staticRenderFns } from "./MedicineView.vue?vue&type=template&id=094a159e&scoped=true"
import script from "./MedicineView.vue?vue&type=script&lang=js"
export * from "./MedicineView.vue?vue&type=script&lang=js"
import style0 from "./MedicineView.vue?vue&type=style&index=0&id=094a159e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a159e",
  null
  
)

export default component.exports